import { allPngs } from "./importAllPngImageFiles";
export function AllPngImageFiles() {
    return (<div style={{ paddingLeft: "1rem" }}>
            <p>This is the complete set of all *.png image files in the portal package. Note that this excludes any images from the design system.</p>
            <AllImages />
        </div>);
}
function AllImages() {
    return (<>
            {Object.keys(allPngs).map((pngName) => (
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        <PngImage pngName={pngName} pngPath={allPngs[pngName] as string}/>))}
        </>);
}
function PngImage({ pngName, pngPath }: {
    pngName: string;
    pngPath: string;
}) {
    return (<>
            <h2>{pngName}</h2>
            <div style={{ paddingLeft: "1rem" }}>
                <img style={{ maxHeight: "500px", maxWidth: "500px" }} src={pngPath} alt={pngName}/>
            </div>
        </>);
}
